<app-page-header title="Home" active_item="Dashboards"></app-page-header>
<!-- ROW OPEN -->
<div class="row">
  <h5>Valores Atualizados</h5>
</div>
<div class="row row-sm">
  <div class="col-xl-3 col-md-6">
    <app-available-balance-card />
  </div>
  <div class="col-xl-3 col-md-6">
    <app-general-balance-card />
  </div>
  <div class="col-xl-3 col-md-6">
    <app-todays-sales-card />
  </div>
  <div class="col-xl-3 col-md-6">
    <app-average-daily-ticket-card />
  </div>
</div>
<!-- ROW END -->
<div class="row middle-header">
  <h5>Valores dos últimos 7 dias</h5>
</div>
<div class="row row-sm">
  <div class="col-xl-6 col-md-6">
    <div class="row row-sm">
      <div class="col-xl-6 col-md-6">
        <app-sales-received-quantity-card />
      </div>
      <div class="col-xl-6 col-md-6">
        <app-received-sales-card />
      </div>
    </div>
    <div class="row row-sm">
      <div class="col-xl-6 col-md-6">
        <app-average-sales-ticket-card />
      </div>
      <div class="col-xl-6 col-md-6">
        <app-receipt-conversion-card />
      </div>
    </div>
  </div>
  <div class="col-xl-6 col-md-6">
    <app-weekly-sales-graph />
  </div>
</div>
<!-- ROW OPEN -->
<div class="row middle-header">
  <h5>Análise Mensal</h5>
</div>
<div class="row last-card">
  <div class="col-xl-12 col-md-12">
    <app-statistics-sales-graph />
  </div>
</div>
<!-- ROW END -->

<!-- CHANGE PASSWORD MODAL-->
<ng-template #changePasswordModal let-modal>
  <!--  SMALL MODAL -->
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Por favor, troque sua senha:</h5>
    </div>
    <div class="modal-body">
      <div class="form-group mt-2">
        <p *ngIf="errorMessage.length > 0" class="text-danger">
          {{ errorMessage }}
        </p>
      </div>
      <div class="form-group mb-3">
        <input
          type="password"
          class="form-control"
          id="nova-senha"
          placeholder="Nova senha"
          [(ngModel)]="novaSenha"
        />
      </div>
      <div class="form-group mb-3">
        <input
          type="password"
          class="form-control"
          id="confirmar-nova-senha"
          placeholder="Confirmar nova senha"
          [(ngModel)]="confirmarNovaSenha"
        />
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="submit"
        class="btn btn-lg btn-primary btn-pill mx-auto d-block"
        (click)="changePassword()"
      >
        ALTERAR
      </button>
    </div>
  </div>
</ng-template>
<!-- END CHANGE PASSWORD MODAL-->
<ng-template #modalFirstAccess let-modal>
  <!--  SMALL MODAL -->
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Nova senha registrada com sucesso!</h5>
    </div>
    <div class="modal-body">
      <h5>Por favor realize o login novamente!</h5>
    </div>
    <div class="modal-footer text-center">
      <button
        type="submit"
        class="btn btn-lg btn-primary btn-pill mx-auto d-block"
        (click)="resetLogin()"
      >
        FECHAR
      </button>
    </div>
  </div>
</ng-template>
